import Types from '../types';

export default (reducerState = [], action) => {
  switch (action.type) {
    case Types.SET_COURSE_ASSESSMENTS:
      return action.payload;
    default:
      return reducerState;
  }
};
